/* MURPH · Popup jeu cadeau : sled push, carte à gratter, wall ball.
   1) le jeu  2) cadeau débloqué + e-mail (formulaire client Shopify)  3) inscription faite */
(function () {
  var root = document.getElementById('murph-popup-jeu');
  if (!root || root.__mpj) return; root.__mpj = true;
  var KEY = 'murph_popup_jeu_vu';
  var game = root.getAttribute('data-game');
  var design = root.getAttribute('data-design') === 'true';
  var once = root.getAttribute('data-once') === 'true';
  var delay = parseInt(root.getAttribute('data-delay') || '7', 10) * 1000;
  var screens = {}; root.querySelectorAll('[data-screen]').forEach(function (s) { screens[s.getAttribute('data-screen')] = s; });
  var steps = root.querySelectorAll('.mpj__steps i');
  var lastFocus = null, stopGame = function () {};

  function seen() { try { return !!localStorage.getItem(KEY); } catch (e) { return false; } }
  function markSeen() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
  function show(name) {
    Object.keys(screens).forEach(function (k) { screens[k].hidden = k !== name; });
    var n = name === 'play' ? 1 : (name === 'won' ? 2 : 3);
    steps.forEach(function (s, i) { s.classList.toggle('is-on', i < n); });
    if (name !== 'play') stopGame();
    if (name === 'won') { var inp = root.querySelector('.mpj__field input'); if (inp && window.matchMedia('(hover:hover)').matches) setTimeout(function () { inp.focus(); }, 350); }
  }
  function open(at) {
    lastFocus = document.activeElement;
    root.hidden = false; document.documentElement.classList.add('mpj-lock');
    show(at || 'play');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    if (at === 'play' || !at) startGame();
    var c = root.querySelector('.mpj__close'); if (c) setTimeout(function () { c.focus({ preventScroll: true, focusVisible: false }); }, 50);
  }
  function close() {
    root.classList.remove('is-open'); document.documentElement.classList.remove('mpj-lock'); stopGame(); markSeen();
    setTimeout(function () { root.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  root.querySelectorAll('[data-mpj-close]').forEach(function (b) { b.addEventListener('click', close); });
  root.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  function won(txt) { var w = root.querySelector('[data-won-txt]'); if (w && txt) w.textContent = txt; setTimeout(function () { show('won'); }, 450); }
  var skip = root.querySelector('[data-skip]');
  if (skip) skip.addEventListener('click', function () { var w = root.querySelector('[data-won-txt]'); if (w) w.textContent = 'Cadeau secret réservé'; show('won'); });
  var form = root.querySelector('.mpj__form');
  if (form) form.addEventListener('submit', function () { markSeen(); });

  /* ---------------- SLED PUSH ---------------- */
  function sled() {
    var btn = root.querySelector('[data-sled-btn]'), label = root.querySelector('[data-sled-label]');
    var el = root.querySelector('[data-sled]'), dist = root.querySelector('[data-sled-dist]'), bar = root.querySelector('[data-bar]'), track = root.querySelector('.mpj__track');
    var pos = 0, hold = false, raf = null, last = 0, pressed = false, done = false;
    function paint() {
      var max = track.clientWidth - 112; el.style.transform = 'translateX(' + (pos / 25 * max).toFixed(1) + 'px)';
      dist.textContent = pos.toFixed(1).replace('.', ','); bar.style.width = (pos / 25 * 100).toFixed(1) + '%';
      label.textContent = done ? 'Ligne franchie !' : (hold ? 'Pousse, pousse !' : (pos > 0 ? 'Continue de pousser' : 'Maintiens pour pousser'));
      btn.classList.toggle('is-holding', hold);
    }
    function finish() { done = true; hold = false; pos = 25; paint(); btn.disabled = true; won('Ligne franchie, cadeau débloqué'); }
    function loop(t) { if (!hold) { raf = null; return; } var dt = Math.min(0.25, (t - last) / 1000); last = t; pos = Math.min(25, pos + dt * 8.5); if (pos >= 25) { raf = null; finish(); return; } paint(); raf = requestAnimationFrame(loop); }
    function down(e) {
      if (done || hold) return; if (e.type === 'mousedown' && e.button !== 0) return;
      if (e.type === 'pointerdown') { try { btn.setPointerCapture(e.pointerId); } catch (x) {} }
      pressed = true; hold = true; last = performance.now(); paint(); raf = requestAnimationFrame(loop);
    }
    function up() { if (!hold) return; hold = false; paint(); }
    if (window.PointerEvent) {
      btn.addEventListener('pointerdown', down); ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (n) { btn.addEventListener(n, up); });
    } else {
      btn.addEventListener('mousedown', down); btn.addEventListener('touchstart', down, { passive: true });
      ['mouseup', 'mouseleave', 'touchend', 'touchcancel'].forEach(function (n) { btn.addEventListener(n, up); });
    }
    btn.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    btn.addEventListener('click', function () { if (pressed) { pressed = false; return; } if (done) return; pos = Math.min(25, pos + 5); if (pos >= 25) finish(); else paint(); });
    paint();
    return function () { hold = false; if (raf) cancelAnimationFrame(raf); };
  }

  /* ---------------- CARTE À GRATTER ---------------- */
  function scratch() {
    var cv = root.querySelector('[data-scratch]'), bar = root.querySelector('[data-bar]'), all = root.querySelector('[data-scratch-all]');
    var ctx, dpr, w, h, down = false, lastP = null, n = 0, gone = false;
    function paintCard() {
      var r = cv.getBoundingClientRect(); if (!r.width) { setTimeout(paintCard, 80); return; }
      dpr = Math.min(2, window.devicePixelRatio || 1); w = r.width; h = r.height;
      cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
      ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var g = ctx.createLinearGradient(0, 0, w, h); g.addColorStop(0, '#2b2b2b'); g.addColorStop(1, '#3d3d3d');
      ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
      ctx.strokeStyle = 'rgba(255,255,255,.06)'; ctx.lineWidth = 8;
      for (var x = -h; x < w; x += 22) { ctx.beginPath(); ctx.moveTo(x, h); ctx.lineTo(x + h, 0); ctx.stroke(); }
      ctx.fillStyle = '#fff'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 26px ' + (getComputedStyle(document.documentElement).getPropertyValue('--heading-font-family') || 'Oswald, sans-serif'); ctx.fillText('GRATTE ICI', w / 2, h / 2 - 8);
      ctx.fillStyle = '#45c4c4'; ctx.font = '500 11px "IBM Plex Mono", monospace'; ctx.fillText('M U R P H   ·   C A D E A U   S E C R E T', w / 2, h / 2 + 22);
    }
    function at(e) { var r = cv.getBoundingClientRect(); var p = e.touches ? e.touches[0] : e; return [p.clientX - r.left, p.clientY - r.top]; }
    function rub(e) {
      if (!ctx || gone) return; var p = at(e);
      ctx.globalCompositeOperation = 'destination-out'; ctx.strokeStyle = '#000'; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 38;
      ctx.beginPath(); if (lastP) ctx.moveTo(lastP[0], lastP[1]); else ctx.moveTo(p[0] - 0.1, p[1]); ctx.lineTo(p[0], p[1]); ctx.stroke(); lastP = p;
      if (++n % 5 === 0) measure();
    }
    function measure() {
      var W = cv.width, H = cv.height, d = ctx.getImageData(0, 0, W, H).data, st = Math.max(4, Math.round(12 * dpr)), c = 0, t = 0;
      for (var y = st / 2; y < H; y += st) for (var x = st / 2; x < W; x += st) { t++; if (d[(Math.floor(y) * W + Math.floor(x)) * 4 + 3] < 40) c++; }
      var pct = Math.round(c / t * 100); bar.style.width = pct + '%'; if (pct >= 50) finish();
    }
    function finish() { if (gone) return; gone = true; down = false; bar.style.width = '100%'; cv.classList.add('is-gone'); won('Carte grattée, cadeau débloqué'); }
    function start(e) { down = true; lastP = null; if (e.pointerId !== undefined) { try { cv.setPointerCapture(e.pointerId); } catch (x) {} } rub(e); }
    function move(e) { if (down) rub(e); }
    function end() { down = false; lastP = null; }
    if (window.PointerEvent) { cv.addEventListener('pointerdown', start); cv.addEventListener('pointermove', move); cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end); }
    else { cv.addEventListener('mousedown', start); cv.addEventListener('mousemove', move); window.addEventListener('mouseup', end); cv.addEventListener('touchstart', start, { passive: true }); cv.addEventListener('touchmove', move, { passive: true }); cv.addEventListener('touchend', end); }
    if (all) all.addEventListener('click', finish);
    paintCard();
    return function () {};
  }

  /* ---------------- WALL BALL ---------------- */
  function wall() {
    var btn = root.querySelector('[data-wall-btn]'), label = root.querySelector('[data-wall-label]'), msg = root.querySelector('[data-wall-msg]');
    var needle = root.querySelector('[data-needle]'), zone = root.querySelector('[data-zone]'), ball = root.querySelector('[data-ball]'), target = root.querySelector('[data-target]'), wallEl = root.querySelector('.mpj__wall');
    var tries = 0, flying = false, done = false, raf = null, t0 = performance.now(), n = 50;
    function z() { var h = tries === 0 ? 18 : (tries === 1 ? 28 : 46); return { top: 14 - (tries > 1 ? 6 : 0), h: h }; }
    function paintZone() { var q = z(); zone.style.top = q.top + '%'; zone.style.height = q.h + '%'; }
    function tick(t) { if (!flying) { n = (Math.sin((t - t0) / 1000 * 2.6) + 1) / 2 * 100; needle.style.top = n.toFixed(1) + '%'; } raf = requestAnimationFrame(tick); }
    function throwIt() {
      if (flying || done) return; var q = z(); var inZone = n >= q.top && n <= q.top + q.h; var hit = inZone || tries >= 2;
      var peak = hit ? 0.8 : Math.max(0.25, 0.8 - Math.abs(n - (q.top + q.h / 2)) / 120);
      var H = wallEl.clientHeight - 14 - 30; flying = true; label.textContent = 'Lancer…'; msg.textContent = 'Lancer…';
      var s = performance.now(), upT = 420, downT = 380;
      (function anim(t) {
        var e = t - s, y;
        if (e < upT) { var p = e / upT; y = peak * (1 - (1 - p) * (1 - p)); }
        else if (!hit && e < upT + downT) { var p2 = (e - upT) / downT; y = peak * (1 - p2 * p2); }
        else y = hit ? peak : 0;
        ball.style.transform = 'translateY(' + (-y * H * 0.98).toFixed(1) + 'px)';
        if (e < upT || (!hit && e < upT + downT)) return requestAnimationFrame(anim);
        if (hit) { done = true; target.classList.add('is-hit'); msg.textContent = 'En plein dans la cible !'; label.textContent = 'Bien joué !'; btn.disabled = true; won('Dans la cible, cadeau débloqué'); }
        else { tries++; flying = false; ball.style.transform = ''; label.textContent = 'Lancer'; msg.textContent = tries === 1 ? 'Presque ! La zone s’élargit' : 'Dernier essai, tu vas l’avoir'; paintZone(); }
      })(s);
    }
    if (window.PointerEvent) btn.addEventListener('pointerdown', function (e) { if (e.button === 0 || e.pointerType !== 'mouse') { btn.__p = true; throwIt(); } });
    btn.addEventListener('click', function () { if (btn.__p) { btn.__p = false; return; } throwIt(); });
    paintZone(); raf = requestAnimationFrame(tick);
    return function () { if (raf) cancelAnimationFrame(raf); raf = null; };
  }

  var started = false;
  function startGame() { if (started) return; started = true; stopGame = (game === 'sled' ? sled : (game === 'grattage' ? scratch : wall))() || function () {}; }

  /* Ouverture */
  var state = window.__mpjState;
  if (state) { open(state); if (state === 'done') markSeen(); return; }
  if (design) { open('play'); return; }
  if (once && seen()) return;
  setTimeout(function () { if (!(once && seen())) open('play'); }, delay);
  document.addEventListener('shopify:section:select', function (e) { if (root.closest('[id*="' + e.detail.sectionId + '"]')) open('play'); });
})();
